import { AttachmentOpenAction } from 'owa-attachment-data';
export default {
    OnClick: {
        name: 'AttachmentOnClick',
        customData: (attachmentOpenAction: AttachmentOpenAction) => [attachmentOpenAction],
    },
};
